import { Component } from '@angular/core';

@Component({
  selector   : 'wor-beta-warning',
  template: require('./beta-warning.component.html')
})
export class BetaWarningComponent {}
